import { useState } from 'react';

interface NavbarProps {
  isScrolled: boolean;
}

export default function Navbar({ isScrolled }: NavbarProps) {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const menuItems = [
    { label: 'TOP', href: '/' },
    { label: 'ロッキングとは', href: '/locking' },
    { label: 'セキュリティガイド', href: '/security' },
    { label: '初心者講座', href: '/beginner' },
    { label: '最新ニュース', href: '/news' },
    { label: 'コミュニティ', href: '/community' },
  ];

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white/98 backdrop-blur-md shadow-md' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="flex items-center justify-between h-24">
          <div className="flex items-center">
            <a href="/" className="cursor-pointer hidden lg:block">
              <img
                src="https://static.readdy.ai/image/019c42ef209c92acff15d1e580b417d6/19f5ffb7ee66b02c49330cb25beab366.png"
                alt="Mawari FREAK"
                className="h-14 w-auto object-contain"
              />
            </a>
          </div>

          {/* Desktop Menu */}
          <div className="hidden lg:flex items-center space-x-8">
            {menuItems.map((item) => (
              <a
                key={item.href}
                href={item.href}
                className="text-base font-semibold text-gray-800 hover:text-pink-600 transition-colors cursor-pointer whitespace-nowrap"
              >
                {item.label}
              </a>
            ))}
            <a
              href="/contact"
              className="px-8 py-3.5 bg-gradient-to-r from-pink-500 to-rose-500 text-white text-base rounded-full font-bold hover:shadow-lg transition-all whitespace-nowrap cursor-pointer"
            >
              お問い合わせ
            </a>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="lg:hidden w-10 h-10 flex items-center justify-center text-gray-800 hover:text-pink-600 transition-colors cursor-pointer"
            aria-label="メニュー"
          >
            {isMobileMenuOpen ? (
              <i className="ri-close-line text-3xl"></i>
            ) : (
              <i className="ri-menu-line text-3xl"></i>
            )}
          </button>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="lg:hidden bg-white/98 backdrop-blur-md shadow-lg rounded-lg mt-2 mb-4 py-4">
            {menuItems.map((item) => (
              <a
                key={item.href}
                href={item.href}
                className="block px-6 py-3 text-base font-semibold text-gray-800 hover:text-pink-600 hover:bg-pink-50 transition-colors cursor-pointer"
                onClick={() => setIsMobileMenuOpen(false)}
              >
                {item.label}
              </a>
            ))}
            <a
              href="/contact"
              className="block mx-6 mt-4 px-8 py-3.5 bg-gradient-to-r from-pink-500 to-rose-500 text-white text-base rounded-full font-bold text-center hover:shadow-lg transition-all cursor-pointer"
              onClick={() => setIsMobileMenuOpen(false)}
            >
              お問い合わせ
            </a>
          </div>
        )}
      </div>
    </nav>
  );
}